<div class="greenness-survey">
  <div class="greenness-intro" [class.web-app]="webApp">
    <h1 class="ds-color-core-neutral-10" [ngClass]="webApp ? 'ds-title-3' : 'ds-heading-1'">{{
      'GREENNESS.' + translationKey + '.title' | translate
    }}</h1>
    <p class="ds-running-2 ds-color-core-neutral-8">
      {{ 'GREENNESS.' + translationKey + '.description' | translate }}
    </p>
  </div>
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    @if (showSurvey === 'greenness' || showSurvey === 'greenness_and_finance') {
      <div class="greenness-question">
        <h2 class="ds-heading-2">{{ 'GREENNESS.' + translationKey + '.greennessQuestion' | translate }}</h2>
        <app-ds-scale [numberOfItems]="10" [showLabels]="true" formControlName="score">
          <span class="ds-caption-3 ds-color-core-neutral-7">{{ 'GREENNESS.' + translationKey + '.greennessLabelLow' | translate }}</span>
          <span class="ds-caption-3 ds-color-core-neutral-7">{{ 'GREENNESS.' + translationKey + '.greennessLabelNeutral' | translate }}</span>
          <span class="ds-caption-3 ds-color-core-neutral-7">{{ 'GREENNESS.' + translationKey + '.greennessLabelHigh' | translate }}</span>
        </app-ds-scale>
      </div>
    }

    @if (showSurvey === 'finance' || showSurvey === 'greenness_and_finance') {
      <div class="greenness-question">
        <div class="greenness-header" [class.opened]="infoList['income']">
          <h2 class="ds-heading-2">{{ 'GREENNESS.' + translationKey + '.incomeQuestion' | translate }}</h2>
          <app-ds-icon name="info" size="icon-size-1" color="var(--color-core-neutral-5)" (click)="onToggleInfo('income')"></app-ds-icon>
        </div>
        @if (infoList['income']) {
          <p class="ds-ui-3 ds-color-core-neutral-7">{{ 'GREENNESS.' + translationKey + '.incomeHint' | translate }}</p>
        }
        <div class="ds-form-row">
          <app-ds-select
            [options]="incomeOptions"
            [placeholder]="'GREENNESS.' + translationKey + '.incomePlaceholder' | translate"
            formControlName="income"
          ></app-ds-select>
        </div>
      </div>

      <div class="greenness-question">
        <div class="greenness-header" [class.opened]="infoList['worth']">
          <h2 class="ds-heading-2">{{ 'GREENNESS.' + translationKey + '.wealthQuestion' | translate }}</h2>
          <app-ds-icon name="info" size="icon-size-1" color="var(--color-core-neutral-5)" (click)="onToggleInfo('worth')"></app-ds-icon>
        </div>
        @if (infoList['worth']) {
          <p class="ds-ui-3 ds-color-core-neutral-7">{{ 'GREENNESS.' + translationKey + '.wealthHint' | translate }}</p>
        }
        <div class="ds-form-row">
          <app-ds-select
            [options]="netWorthOptions"
            [placeholder]="'GREENNESS.' + translationKey + '.wealthPlaceholder' | translate"
            formControlName="worth"
          ></app-ds-select>
        </div>
      </div>
    }

    <div class="ds-form-row greenness-action">
      <app-ds-button variant="primary" width="auto" type="submit" [size]="webApp ? 'default' : 'small'" [disabled]="form?.invalid"
        >{{ 'GREENNESS.' + translationKey + '.submitButton' | translate }}
      </app-ds-button>
    </div>
  </form>
</div>
